export const state = {

  isAddSiteDialogVisible: false,

  isEditSiteDialogVisible: false,

  isAddFieldDialogVisible: false,

  isEditFieldDialogVisible: false,

  isViewUserDialogVisible: false,

  isAddNewUserDialogVisible: false,

  isViewPasswordValidationDelete: false,

  isManageSnoozeNotificationsDialogVisible: false,

  isAddSnoozeNotificationDialogVisible: false,

  isEditSnoozeNotificationDialogVisible: false,

  isAddUserDialogVisible: false,

  isEditUserDialogVisible: false,

  isEditFieldInfoSettingsDialogVisible: false,

  isEditTransmitterDialogVisible: false,

  isEditTransmitterConfigDialogVisible: false,

  isViewStatusDialogVisible: false,

  isEditSensorDialogVisible: false,

  isViewSensorDialogVisible: false,

  isAddFirmwareDialogVisible: false,

  isTransmitterSensorsDialogVisible: false,

};

export const mutations = {
  showViewPasswordValidationDeleteDialog() {
    state.isViewPasswordValidationDelete = true;
  },
  hideViewPasswordValidationDeleteDialog() {
    state.isViewPasswordValidationDelete = false;
  },

  showManageSnoozeNotificationsDialog() {
    state.isManageSnoozeNotificationsDialogVisible = true;
  },

  hideManageSnoozeNotificationsDialog() {
    state.isManageSnoozeNotificationsDialogVisible = false;
  },

  showAddSnoozeNotificationDialog() {
    state.isAddSnoozeNotificationDialogVisible = true;
  },

  hideAddSnoozeNotificationDialog() {
    state.isAddSnoozeNotificationDialogVisible = false;
  },

  showEditSnoozeNotificationDialog() {
    state.isEditSnoozeNotificationDialogVisible = true;
  },

  hideEditSnoozeNotificationDialog() {
    state.isEditSnoozeNotificationDialogVisible = false;
  },

  showAddFirmwareDialog() {
    state.isAddFirmwareDialogVisible = true;
  },

  hideAddFirmwareDialog() {
    state.isAddFirmwareDialogVisible = false;
  },

  showTransmitterSensorsDialog() {
    state.isTransmitterSensorsDialogVisible = true;
  },
  hideTransmitterSensorsDialog() {
    state.isTransmitterSensorsDialogVisible = false;
  },

  showAddUserDialog() {
    state.isAddUserDialogVisible = true;
  },
  hideAddUserDialog() {
    state.isAddUserDialogVisible = false;
  },

  showEditUserDialog() {
    state.isEditUserDialogVisible = true;
  },
  hideEditUserDialog() {
    state.isEditUserDialogVisible = false;
  },

  showAddSiteDialog() {
    state.isAddSiteDialogVisible = true;
  },
  hideAddSiteDialog() {
    state.isAddSiteDialogVisible = false;
  },

  showEditSiteDialog() {
    state.isEditSiteDialogVisible = true;
  },
  hideEditSiteDialog() {
    state.isEditSiteDialogVisible = false;
  },

  showAddFieldDialog() {
    state.isAddFieldDialogVisible = true;
  },
  hideAddFieldDialog() {
    state.isAddFieldDialogVisible = false;
  },

  showEditFieldDialog() {
    state.isEditFieldDialogVisible = true;
  },

  hideEditFieldDialog() {
    state.isEditFieldDialogVisible = false;
  },

  showEditFieldInfoSettingsDialog() {
    state.isEditFieldInfoSettingsDialogVisible = true;
  },

  hideEditFieldInfoSettingsDialog() {
    state.isEditFieldInfoSettingsDialogVisible = false;
  },

  showEditTransmitterDialog() {
    state.isEditTransmitterDialogVisible = true;
  },
  hideEditTransmitterDialog() {
    state.isEditTransmitterDialogVisible = false;
  },

  showEditTransmitterConfigDialog() {
    state.isEditTransmitterConfigDialogVisible = true;
  },
  hideEditTransmitterConfigDialog() {
    state.isEditTransmitterConfigDialogVisible = false;
  },

  showViewStatusDialog() {
    state.isViewStatusDialogVisible = true;
  },

  hideViewStatusDialog() {
    state.isViewStatusDialogVisible = false;
  },

  showEditSensorDialog() {
    state.isEditSensorDialogVisible = true;
  },

  hideEditSensorDialog() {
    state.isEditSensorDialogVisible = false;
  },

  showViewSensorDialog() {
    state.isViewSensorDialogVisible = true;
  },

  hideViewSensorDialog() {
    state.isViewSensorDialogVisible = false;
  },

  showViewUserDialog() {
    state.isViewUserDialogVisible = true;
  },
  hideViewUserDialog() {
    state.isViewUserDialogVisible = false;
  },

  showAddNewUserDialog() {
    state.isAddNewUserDialogVisible = true;
  },
  hideAddNewUserDialog() {
    state.isAddNewUserDialogVisible = false;
  },

};
